import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AttachmentsTable } from './AttachmentsTable';
export { AttachmentsTable };
/**
 * `BuildingAttachments` -- task-19's composition root, mounted by `react_component` from
 * `buildings/tabs/_attachments.html.erb` when `building_attachment_direct_uploads_enabled?`
 * is true. `AttachmentsTable` already composes the table (task-16), inline-edit cells
 * (task-17), mass actions (task-18) and the upload drawer (task-09) -- this wrapper's own
 * job is only the `QueryClientProvider` every mounted island owns for itself (mirrors
 * `CustomerFileDrop`'s own entry component).
 */
function BuildingAttachments(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(AttachmentsTable, Object.assign({}, props))));
}
export default BuildingAttachments;
